import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Highlight from "../components/highlight";
import { useSelector } from "react-redux";

// Todo: Need to add new layout in future
const Profile = () => {
  const user = useSelector((state) => state?.virtualizer?.currentUser);
  const { name, picture, email } = user;

  const nameStyle = { color: "white" };
  const emailStyle = { color: "#5c9eec" };

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={2}>
          <img
            src={picture}
            alt="Profile"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
          />
        </Col>
        <Col md>
          <h2 style={nameStyle}>{name}</h2>
          <p style={emailStyle}>{email}</p>
        </Col>
      </Row>
      <Row>
        <Highlight>{JSON.stringify(user, null, 2)}</Highlight>
      </Row>
    </Container>
  );
};

export default Profile;
